import { gql } from '@apollo/client';

import { MessageFragment } from '../fragments';
import { Message } from '../../types';

export interface GetMessagesQueryResult {
  messagesPayload: {
    unseen: number;
    messages: Message[];
  };
}

export const getMessagesQuery = gql`
  query GetMessagesQuery {
    messagesPayload @rest(type: "MessagesPayload", path: "messages") {
      unseen
      messages: notifications @type(name: "Message") {
        ...Message
      }
    }
  }
  ${MessageFragment}
`;
